import { type FC } from 'react';
import type { InputTextProps } from './types';
import { Input } from '../Input';
import { FormControl } from '../FormControl';
import { FormLabel } from '../FormLabel';
import { FormErrorMessage } from '../FormErrorMessage';

export const InputText: FC<InputTextProps> = ({ 
  label,
  errorMessage,
  type = 'text',
  formControlProps,
  ...props
}) => {
  return (
    <FormControl isInvalid={!!errorMessage} {...formControlProps}>
      <Input type={type} isInvalid={!!errorMessage} {...props} />
      <FormLabel>{label}</FormLabel>
      {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
    </FormControl>
  );
};
